import {getAppSessionCookieHeader} from "../appCookie";
import api from "../../Api";

export const getCartFull = async (guid, referrer) => {
  let _refferer = referrer ? '?referrer=' + referrer : '';
  return await api.get('cart/full/' + guid + _refferer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCustomerCartTab = async (guid, referrer) => {
  let _referrer = referrer ? '?referrer=' + referrer : '';
  return await api.get('cart/tab/' + guid + _referrer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCustomerCartFull = async (guid, referrer) => {
  let _referrer = referrer ? '?referrer=' + referrer : '';
  return await api.get('cart/full/' + guid + _referrer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const reorderFromFavorites = async (guid, request) => {
  const resp = await api.post('cart/favorites/reorder/' + guid + getAppSessionCookieHeader(), request).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const validateGiftCardToken = async (req) => {
  return await api.post('cart/gift/card/validate' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  }).catch(function (error) {
    throw new Error(handleError(error).message);
  });
}

export const updateCartGift = async (clientGuid, req) => {
  return await api.post('cart/gift/' + clientGuid + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  });
}
export const getCartInvoice = async (clientGuid, guid) => {
  return await api.get('cart/invoice/' + clientGuid + '/' + guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getCartInvoiceGroup = async (clientGuid, guid, referrer) => {
  let _referrer = referrer ? '?referrer=' + referrer : '';
  return await api.get('cart/invoice/group/' + clientGuid + '/' + guid + _referrer + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}


export const updateMemberBillingItem = async (cartItem) => {
  return await api.post('cart/billDate' + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const saveCartForm = async (guid, form) => {
  return await api.post('cart/form/' + guid + getAppSessionCookieHeader(), form).then((response) => {
    return response.data;
  });
}

export const removeAttendees = async (client, req) => {
  return await api.post('cart/attendees/remove/' + client.guid + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  });
}

export const saveCustomerFamily = async (customer) => {
  const resp = await api.post('profile/family/save' + getAppSessionCookieHeader(), customer).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const updateAttendees = async (cart, client) => {
  return await api.post('cart/attendees/' + client.guid + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const getCustomerCartFamilyMembers = async (client) => {
  return await api.get('cart/familyMembers/' + client.guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const checkoutTip = async (client, cart) => {
  return await api.post('cart/tip/' + client?.guid + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const setupTerminal = async (cart, client) => {
  return await api.post('cart/terminal/setup/' + (client?.guid || 'employee') + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const checkout = async (cart, client) => {
  return await api.post('cart/checkout/' + client.guid + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  })
}

export const guestCheckout = async (cart) => {
  return await api.post('cart/checkout/kiosk' + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  })
}


export const lookupClientSecret = async (client) => {
  let clientEndpoint = client && client.guid ? ('billing/secret/' + client.guid) : 'billing/secret/kiosk';
  return await api.post(clientEndpoint + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const addtoWaitlist = async (inventory) => {
  return await api.post('cart/waitlist' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const addClientToWaitlist = async (inventory, guid) => {
  return await api.post('cart/waitlist/' + guid + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}


export const clientUpdateCart = async (inventory, guid) => {
  return await api.post('cart/update/' + guid + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const clientGiftCard = async (inventory, guid) => {
  if (!guid) {
    let err = {
      error: true,
      message : 'Customer not found!'
    }
    return err;
  }
  return await api.post('cart/giftcard/assign/' + guid + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const clientAddToCart = async (inventory, guid) => {
  if (!guid) {
    let err = {
      error: true,
      message : 'Customer not found!'
    }
    return err;
  }
  return await api.post('cart/add/' + guid + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const addToCartKiosk = async (inventory) => {
  return await api.post('cart/add/kiosk' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const getKioskCart = async () => {
  return await api.get('cart/items/kiosk' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const getKioskCartFull = async () => {
  return await api.get('cart/full/kiosk' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const clearCustomerCart = async (client) => {
  return await api.post('cart/clear/customer/' + client.guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const tabCustomerCart = async (client) => {
  return await api.post('cart/tab/customer/' + client.guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const saveCustomerTabToCart = async (client) => {
  return await api.post('cart/tab/cart/customer/' + client.guid + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}



export const saveCustomerCartItemToTab = async (client, cartItem) => {
  return await api.post('cart/customer/toggle/tab/' + client.guid + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const saveCustomerTabItemToCart = async (client, cartItem) => {
  return await api.post('cart/customer/toggle/cart/' + client.guid + getAppSessionCookieHeader(), cartItem).then((response) => {
    return response.data;
  });
}

export const clearKioskCart = async () => {
  return await api.post('cart/clear/kiosk' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

function handleError(error) {
  let err = {
    error: true,
    message: error.response.data.message
  }
  return err;
};
